import Controller, { OnClick, OnMount, OnOpen, OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import {Inject} from '@odinjs/odin';
import BaseController from '../BaseController';
import InformationBarUtils from '../commons/header/information-bar-header-utils';
import { PanelAPI } from '@philips-internal/oswald-ui-components';
import { ApplicationRoute } from '../../constants/routes';

import './encounter-patient-detail-controller.css'
import { FoundationUtils } from '../../utils/foundation-utils';
import { HistoryService, HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../constants/endpoints';
import { EncounterPatientDetailAliases } from '../../codegen/constants/aliases/encounter-patient-detail-aliases';

interface RouteParams {
  encounterId: number;
  isExamCollect: string;
  patientId: string;
}

enum ModulePermissions {
  YES = 'S',
  NO  = 'N',
}

@Controller({component: 'general-layout', fragment: 'encounter-patient-detail'})
class EncounterPatientDetailController extends BaseController {

  @Inject(EncounterPatientDetailAliases.CONTAINER_PANEL_BUTTON_VIEW_PRESCRIPTIONS)
  buttonViewPrescriptions!: PanelAPI;

  @Inject(EncounterPatientDetailAliases.CONTAINER_PANEL_BUTTON_VIEW_PRESCRIPTIONS_PADDING)
  backgroundButton!: PanelAPI;

  @Inject('panel-button-patient-confirmation')
  panelButtonPatientConfirmation!: PanelAPI;

  getParamTwsOrTasy(parameterTwsOrTasy: string): string | null {
    return FoundationUtils.findModuleParam('PEP#9127', parameterTwsOrTasy) as string;
  }

  disableNavigationOptions(): void {
    const clinicalNotes = this.getParamTwsOrTasy('ALLOW_ACCESS_CLINICAL_NOTES#1');
    const vitalSign = this.getParamTwsOrTasy('ALLOW_ACESS_VITAL_SIGN#2');
    const labExams = this.getParamTwsOrTasy('ALLOW_ACESS_LAB_EXAMS#3');
    const nonLabExams = this.getParamTwsOrTasy('ALLOW_ACESS_NON_LAB_EXAMS#4');
    const registerVitalSign = this.getParamTwsOrTasy('OPEN_NEW_REGISTER_VITAL_SIGN#5');
    const securityAlert = this.getParamTwsOrTasy('ALLOW_ACCESS_TO_VIEW_SECURITY_ALERTS#6');
    const diagnosis = this.getParamTwsOrTasy('ALLOW_ACCESS_TO_VIEW_DIAGNOSIS#7');
    const prescriptions = this.getParamTwsOrTasy('ALLOW_YOU_TO_VIEWS_CURRENT_PRESCRIPTIONS#8');
    const respiratoryMonitoring = this.getParamTwsOrTasy('ALLOW_ACCESS_RESPIRATORY_MONITORING#13');
    const devices = this.getParamTwsOrTasy('ALLOW_ACCESS_DEVICES#14');
    const intakesAndOutputs = this.getParamTwsOrTasy('ALLOW_ACCESS_INTAKES_AND_OUTPUTS#11');
    const hydricBalance = this.getParamTwsOrTasy('ALLOW_ACCESS_HYDRIC_BALANCE#12');
    const scoreAndIndexes = this.getParamTwsOrTasy('ALLOW_ACCESS_SCORES_AND_INDEXES#15');
    const healthHistory = this.getParamTwsOrTasy('ALLOW_ACCESS_HEALTH_HISTORY#16');

    if (scoreAndIndexes !== ModulePermissions.YES) {
      applicationContext.hideModuleOption('PEP#9127', 'title.form.score-and-indexes');
    }

    if (devices !== ModulePermissions.YES) {
      applicationContext.hideModuleOption('PEP#9127', 'title.form.devices-list');
    }

    if (clinicalNotes !== ModulePermissions.YES) {
      applicationContext.hideModuleOption('PEP#9127', 'function.clinical-notes');
    }

    if (vitalSign !== ModulePermissions.YES && respiratoryMonitoring !== ModulePermissions.YES) {
      applicationContext.hideModuleOption('PEP#9127', 'function.vital-signs');
    }

    if (labExams !== ModulePermissions.YES) {
      applicationContext.hideModuleOption('PEP#9127', 'function.laboratory-exams');
    }

    if (nonLabExams !== ModulePermissions.YES) {
      applicationContext.hideModuleOption('PEP#9127', 'function.non-lab-exams');
    }

    if (registerVitalSign === ModulePermissions.YES) {
      applicationContext.hideModuleOption('PEP#9127', 'function.vital-signs');
    } else {
      applicationContext.hideModuleOption('PEP#9127', 'function.vital-signs-create');
    }

    if (securityAlert && securityAlert !== ModulePermissions.YES) {
      applicationContext.hideModuleOption('PEP#9127', 'text.security-alert');
    }

    if (diagnosis && diagnosis !== ModulePermissions.YES) {
      applicationContext.hideModuleOption('PEP#9127', 'healh.diagnosis');
    }

    if (prescriptions !== ModulePermissions.YES) {
      applicationContext.hideModuleOption('PEP#9127', 'text.prescriptions');
    }

    if (intakesAndOutputs === ModulePermissions.NO && hydricBalance === ModulePermissions.NO) {
      applicationContext.hideModuleOption('PEP#9127', 'text.intakes-and-outputs');
    }

    if (healthHistory !== ModulePermissions.YES) {
      applicationContext.hideModuleOption('PEP#9127', 'text.health-history');
    }
  }

  patientConfirmation(): void {
    const { patientId, encounterId, isExamCollect } = this.historyService.getCurrentRouteParams();
    const route = `${ApplicationRoute.EXAM_COLLECTION}${ApplicationRoute.SEARCH_PATIENT}${ApplicationRoute.EXAM_COLLECT_PATIENT_CONFIRMATION}${ApplicationRoute.EXAM_COLLECT_PRESCRIPTIONS_LIST}`

    if (Number(isExamCollect) === 1) {
      applicationContext.redirect(route, {
        encounterId,
        patientId,
      });
    }
  }

  @OnOpen({target: 'encounter-patient-detail'})
  onMountInfoBar(): void {

    const event = new CustomEvent('setCollapsedInformationBar', {detail: false});
    dispatchEvent(event);

  }

  @OnMount({target: 'general-layout'})
  onMount(): void {

    const params = HistoryService.getCurrentRouteParams() as unknown as RouteParams;

    const isExamCollect = params.isExamCollect;
    const encounterId = params.encounterId;
    const patientId = params.patientId;

    HttpService.get(Endpoint.SUEP_CODE, {encounterId})
      .then(response => {
        const suepId = response.body;
        !suepId ? InformationBarUtils.collapsedBar = false : InformationBarUtils.collapsedBar = true;
      });

    if (Number(isExamCollect) === 1) {
      InformationBarUtils.collapsedBar = false;
      this.buttonViewPrescriptions.setVisible(true);
      this.backgroundButton.setVisible(true);
    }

    this.disableNavigationOptions();

    this.context.set({
      encounterId,
      patientId,
    });

    const event = new CustomEvent('setCollapsedInformationBar', {detail: false});
    dispatchEvent(event);
  }

  @OnUnmount({target: 'general-layout'})
  onUnmount(): void {
    const event = new CustomEvent('setCollapsedInformationBar', {detail: true});
    dispatchEvent(event);
  }

  @OnClick({target: 'button-view-prescriptions'})
  onClickButtonViewPrescriptions(): void {
    this.patientConfirmation()
  }
}

export default EncounterPatientDetailController;
